import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { environment } from '@environments/environment';
import { catchError, of } from 'rxjs';
import { ITeamLineUp } from '../models/team-line-up.models';

@Injectable({
  providedIn: 'root',
})
export class TeamLineUpService {
  private http = inject(HttpClient);
  private env = environment;
  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  isLoadingTeamLineUp = signal<boolean>(false);
  isErrorTeamLineUp = signal<boolean>(false);
  teamLineUp = signal<ITeamLineUp[] | null>(null);

  constructor() {}

  getTeamLineUp(
    teamId: string,
    callback?: () => void,
    isRefreshing: boolean = false
  ) {
    if (!isRefreshing) this.isLoadingTeamLineUp.set(true);
    this.isErrorTeamLineUp.set(false);

    this.http
      .get<ITeamLineUp[] | null>(
        `${this.env.baseUrlWeb}/teams/${teamId}/squad`,
        {
          headers: this.headers,
        }
      )
      .pipe(
        catchError((_) => {
          this.isLoadingTeamLineUp.set(false);
          this.isErrorTeamLineUp.set(true);

          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.teamLineUp.set(null);
          this.isLoadingTeamLineUp.set(false);
          return;
        }

        this.teamLineUp.set(data);
        callback && callback();
        this.isLoadingTeamLineUp.set(false);
      });
  }
}
